import React from 'react';
import { EArchiveItem } from './EArchiveListItem';
// @ts-ignore
import styles from './EArchiveListItemListView.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import EArchiveListItemStatusBadge from './EArchiveListItemStatusBadge';
import FormattedDate from '../../../../Components/FormattedDate';
import EArchiveListItemVerificationBadge from './EArchiveListItemVerificationBadge';
import UserAvatarImage from '../../../../Components/UserAvatar/UserAvatarImage';
import usePatientIdentification from '../../../Patient/Hooks/usePatientIdentification';
import { User } from '../../../../graphql/graphql';
import EArchiveListItemSourceBadge from './EArchiveListItemSourceBadge';

interface Props {
	item: EArchiveItem;
	onClick: () => void;
}

const EArchiveListItemListView: React.FC<Props> = ({ item, onClick }) => {
	const { t } = useTranslation();
	const { identification } = usePatientIdentification(item.user as User);

	return (
		<div className={styles.wrapper}>
			<div className={styles.leftSide}>
				<div className={styles.image}>
					<UserAvatarImage
						userId={item.user.id}
						profileImageUrl={item.user.profileImageUrl}
					/>
				</div>
				<div className={styles.content}>
					<div className={styles.name} onClick={onClick}>
						{item.user?.profile?.fullName ?? item.user?.email}
					</div>
					{identification.value && (
						<div className={styles.text}>
							{t(identification.title)}: {identification.value}
						</div>
					)}
					{item.user?.profile?.insuranceCompanyTermItem && (
						<div className={styles.text}>
							{t('base.insuranceShort')}:{' '}
							{item.user.profile.insuranceCompanyTermItem.value} -{' '}
							{item.user.profile.insuranceCompanyTermItem.value2}
						</div>
					)}
				</div>
			</div>
			<div className={styles.rightSide}>
				{item.user.profile?.address.fullAddress && (
					<div className={styles.item}>
						{t('base.shared.address')}:{' '}
						<span>{item.user.profile?.address.fullAddress}</span>
					</div>
				)}
				{item.user?.profile && (
					<div className={styles.item}>
						{t('base.shared.dateOfBirth')}:{' '}
						<span>
							<FormattedDate date={item.user.profile.birthDate} />
						</span>
					</div>
				)}
				{item.user?.isChild &&
					item.user?.parents?.map(parent => (
						<div className={styles.row}>
							{parent.profile?.fullName && (
								<div className={styles.item}>
									{t('base.shared.legalRepresentative')}:{' '}
									<span>{parent.profile.fullName}</span>
								</div>
							)}
							{parent?.email && (
								<div className={styles.item}>
									{t('base.shared.email')}: <span>{parent.email}</span>
								</div>
							)}
							{parent?.formattedPhoneNumber && (
								<div className={styles.item}>
									{t('base.phoneShort')}:{' '}
									<span>{parent?.formattedPhoneNumber}</span>
								</div>
							)}
						</div>
					))}
				<div className={styles.row}>
					{item.user.email && (
						<div className={styles.item}>
							{t('base.shared.email')}: <span>{item.user.email}</span>
						</div>
					)}
					{item.user?.formattedPhoneNumber && (
						<div className={styles.item}>
							{t('base.phoneShort')}:{' '}
							<span>{item.user.formattedPhoneNumber}</span>
						</div>
					)}
				</div>
				<div className={styles.badgeWrapper}>
					{item.user.workplaceMember?.source && (
						<EArchiveListItemSourceBadge
							source={item.user.workplaceMember.source}
						/>
					)}
					<EArchiveListItemStatusBadge
						status={item.status}
						hasMeddi={item.user.hasMeddi}
					/>
					<EArchiveListItemVerificationBadge
						csszResult={item.user.vzpResult}
						vzpResult={item.user.csszResult}
					/>
				</div>
			</div>
		</div>
	);
};

export default EArchiveListItemListView;
